export default "__VITE_ASSET__m8R6TgWxwop2r_xOIPNRtg__ 200w, __VITE_ASSET__6MQCagmCrZzS5dHPKhXWKQ__ 500w, __VITE_ASSET__U2YZxvNlcnuoWcGKwa9Wsw__ 1000w";